import { render, staticRenderFns } from "./FileListVertical.vue?vue&type=template&id=6a66827f&scoped=true"
import script from "./FileListVertical.vue?vue&type=script&lang=js"
export * from "./FileListVertical.vue?vue&type=script&lang=js"
import style0 from "./FileListVertical.vue?vue&type=style&index=0&id=6a66827f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66827f",
  null
  
)

export default component.exports